import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UserService } from 'src/app/shared-lib/domains/user';

@Component({
  selector: 'app-whatsapp-unsubscribe',
  templateUrl: './whatsapp-unsubscribe.component.html',
  styleUrls: ['./whatsapp-unsubscribe.component.scss'],
  standalone: true,
  imports: [RouterModule]
})
export class WhatsappUnsubscribeComponent implements OnInit {

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private location = inject(Location);
  private userService = inject(UserService);

  constructor() {
    this.route.queryParams.subscribe(async params => {
      const userId = params.u;
      // Sustituye la entrada del historial por '/' sin disparar el router.
      // Así la URL de unsubscribe desaparece del historial y el botón
      // "adelante" nunca puede volver a esta página.
      this.location.replaceState('/');
      if (userId) {
        await this.userService.unsubscribeFromWhatsapp(userId);
      }
    });
  }

  ngOnInit() { }

  goHome() {
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
